var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"field"},[_c('input',{staticClass:"btn",attrs:{"type":"submit"},domProps:{"value":_vm._f("translate")('Uložit')},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$emit('submit')}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f9603a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ButtonInput.vue
// module id = qRUD
// module chunks = 0